import { render } from "./GridTemeiuriLegale.vue?vue&type=template&id=aa6c5510&ts=true"
import script from "./GridTemeiuriLegale.vue?vue&type=script&lang=ts"
export * from "./GridTemeiuriLegale.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__